import { render, staticRenderFns } from "./procedure.vue?vue&type=template&id=23ed05de&scoped=true"
var script = {}
import style0 from "./procedure.vue?vue&type=style&index=0&id=23ed05de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ed05de",
  null
  
)

export default component.exports